import { WarningTriangleIcon } from "@images/svgIcons/warningIcon"
import { word } from "@modules/core/utils/i18n"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { HUDialog } from "@modules/ui/components/popup/huDialog"
import { useImperativeHandle, useState } from "react"
import { useTheme } from "styled-components"

type ProgramBundlePauseOnOffModalProps = {
  onConfirmUnfollow: () => void
  ref: React.Ref<ProgramBundlePauseOnOffModalRef>
}

export type ProgramBundlePauseOnOffModalRef = {
  open: () => void
}

export function ProgramBundlePauseOnOffModal({ onConfirmUnfollow, ref }: ProgramBundlePauseOnOffModalProps) {
  const [dialogIsVisible, setDialogIsVisible] = useState(false)

  const theme = useTheme()

  const closeDialog = () => {
    setDialogIsVisible(false)
  }

  const onClickConfirm = () => {
    onConfirmUnfollow()
    closeDialog()
  }

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogIsVisible(true)
    },
  }))

  return (
    <HUDialog
      visible={dialogIsVisible}
      header=""
      onHide={closeDialog}
      style={{ height: 332, width: 512 }}
      contentStyle={{ padding: "0.5rem 1.5rem" }}
      headerClassName="h-1rem"
      className="rounded-33"
    >
      <div className="flex flex-column align-items-center w-full gap-6">
        <div className="flex flex-column align-items-center text-center w-full gap-3">
          <WarningTriangleIcon color={theme.neutralColor600} width={50} height={50} />

          <HUText fontStyle="TL">{word("programBundle.follow.remove.onoff.paused.title")}</HUText>
        </div>

        <HUText fontStyle="BM" className="text-center">
          {word("programBundle.follow.remove.onoff.paused.explanation")}
        </HUText>

        <div className="flex flex-row gap-5 w-full align-items-center justify-content-between">
          <HUButton
            type="Default"
            colorType="Quaternary"
            size="S"
            text={word("global.cancel")}
            className="w-full"
            onClick={closeDialog}
          />
          <HUButton
            type="Default"
            colorType="Primary"
            size="S"
            text={word("programBundle.follow.remove.onoff.confirm")}
            className="w-full"
            onClick={onClickConfirm}
          />
        </div>
      </div>
    </HUDialog>
  )
}
